import { render } from "./ConfigYearAddEditDialog.vue?vue&type=template&id=07099550"
import script from "./ConfigYearAddEditDialog.vue?vue&type=script&lang=js"
export * from "./ConfigYearAddEditDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__